import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { ReactComponent as InfoCircle } from '../../../../../assets/icons/u_info-circle.svg';
import './AccordanceTooltip.scss';

type Props = {
  title: string;
  buttonAriaLabel?: string;
  panelClassName?: string;
  children: React.ReactNode;
};

const AccordanceTooltip = ({ title, buttonAriaLabel, panelClassName = '', children }: Props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const tooltipRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div ref={tooltipRef}>
      <button
        type="button"
        className="info-tooltip-icon-button"
        onClick={() => setIsOpen(true)}
        aria-label={buttonAriaLabel}
      >
        <InfoCircle className="info-tooltip-icon" />
      </button>
      {isOpen && (
        <div className={`info-tooltip-panel ${panelClassName}`.trim()} role="dialog" aria-modal="false">
          <div className="info-tooltip-header">
            <p className="info-tooltip-title">{title}</p>
            <button
              type="button"
              className="info-tooltip-close"
              onClick={() => setIsOpen(false)}
              aria-label="Cerrar tooltip"
            >
              <CloseIcon fontSize="small" />
            </button>
          </div>
          <div className="info-tooltip-body">{children}</div>
        </div>
      )}
    </div>
  );
};

export default AccordanceTooltip;
